import Modal from "react-modal";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SendArrowIcon from "../icons/SendArrowIcon";
import WaiterIcon from "../icons/WaiterIcon";
import "../../css/WaiterAIModal.css";
import "../../css/CustomerMenu.css";
import { sendQuery } from "../../api/menuApi";

/**
 * A modal component for the WaiterAI interface.
 *
 * @component
 * @param {Boolean} isOpen - Controls whether the modal is open or closed.
 * @param {Function} onRequestClose - Callback function triggered to close the modal, passed down to BaseModal.
 *
 * @returns {JSX.Element} The rendered LoginModal component.
 */
const WaiterAIModal = ({ isOpen, onRequestClose }) => {
  const [messages, setMessages] = useState([
    {
      text: "hi! i’m tasty ai, your virtual dining assistant. i can help you explore the menu, suggest popular dishes, and answer any questions you have. looking for recommendations or need help with an order?",
      sender: "tastyai",
    },
  ]);

  const [customerMessage, setCustomerMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);
  const { menuId } = useParams();
  const frontendPath = window.location.pathname;

  const handleMessageChange = (e) => {
    setCustomerMessage(e.target.value);
  };

  const handleSendMessage = async () => {
    if (!customerMessage.trim()) return; // Checks if the message  is empty

    setMessages((previousMessages) => [
      ...previousMessages,
      { text: customerMessage, sender: "customer" },
    ]);
    setCustomerMessage("");
    setIsLoading(true);
    try {
      const aiResponse = await sendQuery(menuId, frontendPath, customerMessage);
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: aiResponse, sender: "tastyai" },
      ]);
    } catch (error) {
      console.error("Error fetching AI response:", error);
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          text: "Sorry, I'm having trouble answering right now.",
          sender: "tastyai",
        },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  // Makes sure the most recent messages are in frame
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <Modal
      className="waiterai-modal"
      overlayClassName="waiterai-modal-overlay"
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <div className="waiterai-modal-header">
        <h2>tasty ai -- your waiter ai chatbot</h2>
      </div>
      <div className="waiterai-modal-message-block">
        {messages.map((msg, index) => (
          <div className="waiterai-modal-messages">
            <div className={`waiterai-modal-sender-${msg.sender}`}>
              {msg.sender === "customer" ? "you" : "tasty ai"}
            </div>
            <div key={index} className={`waiterai-modal-message-${msg.sender}`}>
              {msg.text}
            </div>
          </div>
        ))}
        <div ref={messagesEndRef} />
        <div className="waiterai-modal-input">
          <input
            className="waiterai-modal-textbox"
            type="text"
            value={customerMessage}
            onChange={handleMessageChange}
            placeholder="message tasty ai"
            onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
          />
          <div
            className="waiterai-modal-send-button"
            onClick={handleSendMessage}
          >
            <SendArrowIcon />
          </div>
        </div>
      </div>
      <div className="CustomerMenu-waiter-ai-button" onClick={onRequestClose}>
        <WaiterIcon />
      </div>
    </Modal>
  );
};

export default WaiterAIModal;
